import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AgrSummaryWrapper} from '@app/themes/agrosense/summary-wrapper-agrosense/agr-summary-wrapper';
import {MsfaSummaryWrapper} from '@app/themes/masofa/msfa-summary-wrapper/msfa-summary-wrapper';
import {TranslatePipe} from '@ngx-translate/core';
import {RouterLink} from '@angular/router';
import {Card} from 'primeng/card';
import {SummaryItemsList} from '@components/ui/summary-items-list/summary-items-list';
import {SummaryWrapper} from '@app/wrappers/summary-wrapper/summary-wrapper';
import {BackButton} from "@components/ui/back-button/back-button";
import {Loading} from '@components/ui/loading/loading';


@NgModule({
  declarations: [
    MsfaSummaryWrapper,
    AgrSummaryWrapper,
    SummaryWrapper
  ],
    imports: [
        CommonModule,
        TranslatePipe,
        RouterLink,
        Card,
        SummaryItemsList,
        BackButton,
        Loading,
    ],
  exports: [SummaryWrapper, MsfaSummaryWrapper]
})
export class ThemeModule {
}
